
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/export-full",
      function () {
        return require("private-next-pages/export-full/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/export-full"])
      });
    }
  